import { Steps } from "antd";
import { ReactNode } from "react";

import VLButton from "views/uikit/Buttons/VLButton";
import ProgressPane from "views/pages/DatasetCreationPage/ProgressPane";
import styles from "./style.module.scss";

export interface WizardStep {
  title: string;
  content: ReactNode;
  isLoading?: boolean;
  icon?: JSX.Element | null;

  disabled?: boolean;
  status?: "wait" | "process" | "finish" | "error";
}

export interface WizardButtonsConfig {
  showNext: boolean;
  showPrev: boolean;
  nextText: string;
  prevText: string;
  disableNextTooltip?: string;
  disablePrevTooltip?: string;
  onNext?: () => void | Promise<void>;
  onPrev?: () => void | Promise<void>;
}

interface VLWizardProps {
  steps: WizardStep[];
  current?: number;
  buttonsConfig?: WizardButtonsConfig;
  showActivityLogs?: boolean;
}

const VLWizard = ({
  steps,
  current = 0,
  buttonsConfig,
  showActivityLogs = false,
}: VLWizardProps) => {
  // All navigation logic should be handled in buttonsConfig
  const handleNext = async () => {
    if (buttonsConfig?.onNext) {
      await buttonsConfig.onNext();
    }
  };

  const handlePrevious = async () => {
    if (buttonsConfig?.onPrev) {
      await buttonsConfig.onPrev();
    }
  };

  const currentStepData = steps[current];

  const showNext = buttonsConfig?.showNext || false;
  const showPrev = buttonsConfig?.showPrev || false;
  const nextText = buttonsConfig?.nextText ?? "Continue";
  const prevText = buttonsConfig?.prevText ?? "Previous";
  const disableNextTooltip = buttonsConfig?.disableNextTooltip ?? "";
  const disablePrevTooltip = buttonsConfig?.disablePrevTooltip ?? "";

  return (
    <div className={styles.wizardContainer}>
      <div className={styles.stepsContainer}>
        <Steps
          items={steps}
          type="default"
          direction="vertical"
          current={current}
          className={styles.steps}
        />
        {showActivityLogs && (
          <ProgressPane
            className={styles.progressPaneWrapper}
            showEmptyLogs={true}
          />
        )}
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.stepContent}>{currentStepData?.content}</div>

        <div className={styles.overflow}></div>
        <div className={styles.buttonsContainer}>
          {showPrev && (
            <VLButton
              disabled={!!disablePrevTooltip}
              tooltip={disablePrevTooltip}
              text={prevText}
              type="default"
              onClick={handlePrevious}
            />
          )}

          {showNext && (
            <VLButton
              disabled={!!disableNextTooltip}
              tooltip={disableNextTooltip}
              text={nextText}
              type="primary"
              onClick={handleNext}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VLWizard;
